import { PermanentJobsApi } from '../clients';

/**
 * Creates onsite interviews for a posting
 * Service layer that orchestrates the API call
 *
 * @param {import('../types/CreateOnsiteInterviews.parameters').ICreateOnsiteInterviewsPayload} payload - Request payload
 * @returns {Promise<void>} Returns void on success (204 No Content)
 */
export const createOnsiteInterviews = async (payload) => {
  await PermanentJobsApi.createOnsiteInterviews(payload);

  // No return value needed for 204 No Content response
  return undefined;
};
